export default __webpack_public_path__ + "static/media/bi_google.eec73fc9.svg";